import React from "react";

export default function Choisiroperations({ k, onClose, onAction }) {
  const handleClick = (action) => {
    console.log(`Action: ${action}, Service Code: ${k}`);

    onClose(); // ← ferme la modal actuelle
    onAction(action, k); // ← déclenche ouverture d'une autre modal dans le parent
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 50,
      }}
      onClick={onClose} // ferme modal au clic sur le backdrop
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "25px",
          padding: "50px 40px",
          width: "90%",
          maxWidth: "500px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          textAlign: "center",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()} // empêche fermeture quand on clique sur la carte
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#555",
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "25px",
          }}
        >
          <AnimatedButton color="#007bff" onClick={() => handleClick(`modify`)}>
            Modify Service
          </AnimatedButton>

          <AnimatedButton
            color="#28a745"
            onClick={() => handleClick(`payment`)}
          >
            Proceed to Service Payment
          </AnimatedButton>

          <AnimatedButton
            color="#dc3545"
            onClick={() => handleClick(`blacklist`)}
          >
            Add to Blacklist
          </AnimatedButton>
        </div>
      </div>
    </div>
  );
}

// Composant bouton animé
const AnimatedButton = ({ color, onClick, children }) => {
  return (
    <button
      onClick={onClick}
      style={{
        fontSize: "1.3rem",
        fontWeight: "bold",
        padding: "18px 30px",
        borderRadius: "12px",
        border: "none",
        width: "100%",
        cursor: "pointer",
        background: color, // <-- couleur uniforme
        color: "#fff",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05) rotate(-1deg)";
        e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1) rotate(0deg)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.25)";
      }}
    >
      {children}
    </button>
  );
};
